var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderarrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6768 82.3539C41.6767 104.846 59.8612 123.031 82.3534 123.03C104.846 123.03 123.03 104.846 123.03 82.3535C123.03 59.8613 104.846 41.6768 82.3538 41.6769C59.8616 41.677 41.6769 59.8617 41.6768 82.3539Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4328 81.5059L83.9277 105.001L87.3187 101.61L67.2149 81.5058L87.319 61.4018L83.9279 58.0108L60.4328 81.5059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.001 83.9279L105.001 79.0835L63.8241 79.0837L63.8241 83.9281L105.001 83.9279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderarrowleft);
export default __webpack_public_path__ + "static/media/Sliderarrowleft.e8e7aeb554b52cea0595d44cee464597.svg";
export { ForwardRef as ReactComponent };